export const SELECT_ELEMENTS = {
    SELECT: 'select-select',
    VALUE: 'select-value',
    OPTION: 'select-option',
    OPTIONS: 'select-options',
};
const PREFIX = 'events';
export const EVENT_TITLE = 'EVENT_TITLE';
export const eventDetails = 'event-details';
export const eventDetailsContent = 'content-container';
export const eventDetailsFullLocation = 'event-full-location';
export const subtitleTimeAndLocation = 'time-and-location';
export const subtitleMembers = 'members';
export const subtitleTickets = 'tickets';
export const header = 'header';
export const headerEventTitle = 'event-title';
export const headerEventDescription = 'event-description';
export const headerShortDateLocation = 'short-date-location';
export const headerShortDate = 'event-short-date';
export const headerShortLocation = 'event-short-location';
export const HEADER_GET_TICKETS_BUTTON = 'get-tickets-button';
export const ABOUT = 'about';
export const ABOUT_SECTION = 'about-section';
export const ABOUT_SECTION_TEXT = 'about-section-text';
export const ABOUT_SECTION_BUTTON = 'about-section-button';
export const ABOUT_SECTION_WRAPPER = 'about-section-wrapper';
export const MAP = 'map';
export const eventImage = 'event-image';
export const RSVP_FORM = 'rsvp-form';
export const CHECKOUT_STEP = (key) => `${PREFIX}.CHECKOUT_STEP-${key}`;
export const CHECKOUT_STEP_TITLE = `${PREFIX}.CHECKOUT_STEP_TITLE`;
export const CHECKOUT_STEP_EDIT = `${PREFIX}.CHECKOUT_STEP_EDIT`;
export const CHECKOUT_BUYER_DETAILS = `${PREFIX}.CHECKOUT_BUYER_DETAILS`;
export const CHECKOUT_SUMMARY_SUBTOTAL = `${PREFIX}.CHECKOUT_SUMMARY_SUBTOTAL`;
export const CHECKOUT_SUMMARY_DISCOUNT = `${PREFIX}.CHECKOUT_SUMMARY_DISCOUNT`;
export const CHECKOUT_SUMMARY_TOTAL = `${PREFIX}.CHECKOUT_SUMMARY_TOTAL`;
export const SHOW_SUMMARY_BUTTON = 'SHOW_SUMMARY_BUTTON';
export const EVENT_DETAILS_MEMBERS = `${PREFIX}.MEMBERS`;
export const MEMBERS_TITLE = `members-title`;
export const UPDATE_MEMBER_EVENT = `${PREFIX}.UPDATE_MEMBER_EVENT`;
export const RSVP_INFO_BUTTON = 'RSVP_INFO_BUTTON';
export const TICKET = 'ticket';
export const TICKET_PRICING_OPTION = 'ticket-pricing-option';
export const RESERVATION_TIMER = 'reservation-timer';
export const COUPON_CODE_EXPAND_BUTTON = 'coupon-code-expand-button';
export const COUPON_FORM = 'coupon-form';
export const ADD_COUPON_BUTTON = 'add-coupon-button';
export const COUPON_CODE_INPUT = 'coupon-code-input';
export const COUPON_CODE_CLEAR = 'coupon-code-clear';
export const COUPON_CODE_SUBMIT = 'coupon-code-submit';
export const COUPON_ERROR = 'coupon-error';
export const COUPON_INPUT_INFO = 'coupon-input-info';
export const COUPON_CHECKING_VALIDITY = 'coupon-checking-validity';
export const COUPON_APPLIED = 'coupon-applied';
export const ADD_GIFT_CARD_BUTTON = 'add-gift-card-button';
export const GIFT_CARD_CODE_INPUT = 'gift-card-code-input';
export const GIFT_CARD_CODE_SUBMIT = 'gift-card-code-submit';
export const GIFT_CARD_CODE_CLEAR = 'gift-card-code-clear';
export const GIFT_CARD_APPLIED = 'gift-card-applied';
export const TICKET_DETAILS_FORM = (index) => `ticket-details-form-${index}`;
export const TICKET_DETAILS_HEADER_TITLE = 'ticket-details-header-title';
export const DESKTOP = 'desktop';
export const MOBILE = 'mobile';
export const ORDER_SUCCESS = 'order-success';
export const ORDER_SUCCESS_TITLE = 'order-success-title';
export const ORDER_SUCCESS_SUBTITLE = 'order-success-subtitle';
export const INVOICE_TITLES = 'invoice-titles';
export const INVOICE_BREAKDOWN = 'invoice-breakdown';
export const DISCOUNT_PRICE = 'discount-price';
export const GIFT_CARD_CONTAINER = 'gift-card-container';
export const PAID_PLAN_DISCOUNT_PRICE = 'paid-plan-discount-price';
export const TAX = 'tax';
export const TAX_LABEL = 'tax-label';
export const WIX_FEE = 'wix-fee';
export const GIFT_CARD = (index) => `gift-card-${index}`;
export const ORDER_SUCCESS_SUMMARY = 'order-success-summary';
export const ORDER_SUCCESS_SUMMARY_WRAPPER = 'order-success-summary-wrapper';
export const SUBTOTAL = 'subtotal';
export const TOTAL_PRICE = 'total-price';
export const BACK_TO_SITE = 'back-to-site';
export const PRINT = 'print';
export const DOWNLOAD = 'download';
export const ORDER_NUMBER = 'order-number';
export const PLACED_ON = 'placed-on';
export const QUANTITY_PICKER = 'quantity-picker';
export const MINUS_BUTTON = 'minus-button';
export const PLUS_BUTTON = 'plus-button';
export const QUANTITY_VALUE = 'quantity-value';
export const RSVP_BUTTON = 'rsvp-button';
export const RSVP_OPENS_LABEL = 'rsvp-opens-label';
export const RSVP_CLOSES_LABEL = 'rsvp-closes-label';
export const CHECKOUT = 'checkout';
export const CHECKOUT_BUTTON = 'checkout-button';
export const CLOSE_BUTTON = 'close-btn';
export const RESERVE_TICKETS_BUTTON = 'reserve-tickets-button';
export const FORM_BUTTON = 'form-button';
export const FORM_INVALID_FIELD = 'form-invalid-field';
export const FORM_ADDRESS_LABEL = 'address-caption';
export const FORM_ADDRESS_INPUT = 'address-input';
export const FORM_ADDRESS_ERROR = 'address-error';
export const FORM_DATE_LABEL = 'date-caption';
export const FORM_DATE_PICKER = 'date-picker';
export const FORM_DATE_INPUT_MONTH = 'date-input-month';
export const FORM_DATE_INPUT_DAY = 'date-input-day';
export const FORM_DATE_INPUT_YEAR = 'date-input-year';
export const FORM_DATE_ERROR = 'date-error';
export const FORM_GUEST_CONTROL_LABEL = 'guests-control-label';
export const FORM_ADDITIONAL_GUEST_SELECT = 'additional-guest-select';
export const PAYMENT_METHOD_SUBMIT = 'payment-method-submit';
export const TICKET_PICKER_PRICE_COLUMN = 'ticket-picker-price-column';
export const TICKET_NAME = 'ticket-name';
export const TICKET_PRICE = 'ticket-price';
export const TICKET_QUANTITY = 'ticket-quantity';
export const TICKET_TOTAL_PRICE = 'ticket-total-price';
export const TICKETS_PICKER = 'tickets-picker';
export const TICKETS_PICKER_TITLES = 'tickets-picker-titles';
export const TICKETS_PICKER_HEADER_TITLE = 'header-title';
export const TICKETS_PICKER_HEADER_PRICE = 'header-price';
export const TICKETS_PICKER_HEADER_QUANTITY = 'header-qty';
export const TICKETS_PICKER_HEADER_TOTAL = 'header-total';
export const TICKETS_PICKER_FOOTER = 'tickets-picker-footer';
export const TICKETS_SUMMARY = 'tickets-summary';
export const TICKET_WRAPPER = 'ticket-wrapper';
export const TICKET_SOLD_OUT = 'ticket-sold-out';
export const TICKET_GOES_ON_SALE = 'ticket-goes-on-sale';
export const TICKET_SALE_ENDS = 'ticket-sale-ends';
export const TICKET_SALE_ENDED = 'ticket-sale-ended';
export const MEMBERSHIP_OFFERS = 'membership-offers';
export const MEMBERSHIP_OFFERS_PROMO = 'membership-offers-promo';
export const MEMBERSHIP_OFFERS_DETAILS = 'membership-offers-details';
export const MEMBERSHIP_OFFERS_PLAN = 'membership-offers-plan';
export const MEMBERSHIP_OFFERS_PLAN_NAME = 'membership-offers-plan-name';
export const MEMBERSHIP_OFFERS_PLAN_BENEFIT = 'membership-offers-plan-benefit';
export const MEMBERSHIP_OFFERS_PLAN_PRICING = 'membership-offers-plan-pricing';
export const MEMBERSHIP_OFFERS_PLAN_INFO = 'membership-offers-plan-info';
export const MEMBERSHIP_OFFERS_BUY = 'membership-offers-buy';
export const MEMBERSHIP_OFFERS_LOGIN = 'membership-offers-login';
export const MEMBERSHIP_SELECTOR = 'membership-selector';
export const SHOW_DETAILS_TOGGLE = 'show-details-toggle';
export const SHOW_DETAILS_TOGGLE_HIDE = 'show-details-toggle-hide';
export const SHOW_DETAILS_TOGGLE_SHOW = 'show-details-toggle-show';
export const MEMBERSHIP_SELECTOR_OPTION_TITLE = 'membership-selector-option-title';
export const MEMBERSHIP_SELECTOR_OPTION_SUBTITLE = 'membership-selector-option-subtitle';
export const FIRST_NAME_INPUT = 'first-name-input';
export const LAST_NAME_INPUT = 'last-name-input';
export const THANK_YOU_MESSAGE = 'thank-you-message';
export const THANK_YOU_MESSAGE_TITLE = 'thank-you-message-title';
export const THANK_YOU_MESSAGE_NOTIFICATION = 'thank-you-message-notification';
export const ADD_TO_CALENDAR = 'add-to-calendar';
export const CALENDAR_GOOGLE = 'calendar-google';
export const CALENDAR_OUTLOOK = 'calendar-outlook';
export const CALENDAR_ICAL = 'calendar-ical';
export const DOWNLOAD_TICKETS = 'download-tickets';
export const PREPARING_TICKETS = 'preparing-tickets';
export const DOWNLOAD_PDF = 'download-pdf';
export const DOWNLOAD_APPLE_WALLET = 'download-apple-wallet';
export const APPLE_WALLET_TICKET_NAME = 'apple-wallet-ticket-name';
export const APPLE_WALLET_TICKET_NUMBER = 'apple-wallet-ticket-number';
export const APPLE_WALLET_TICKET_BUYER = 'apple-wallet-ticket-buyer';
export const APPLE_WALLET_TICKET = 'apple-wallet-ticket';
export const SOCIAL_SHARE_TITLE = 'social-share-title';
export const SOCIAL_SHARE = 'social-share';
export const SOCIAL_SHARE_ICON_FACEBOOK = 'social-share-icon-facebook';
export const SOCIAL_SHARE_ICON_TWITTER = 'social-share-icon-twitter';
export const SOCIAL_SHARE_ICON_LINKEDIN = 'social-share-icon-linkedin';
export const NAME = 'name';
export const TICKET_DESCRIPTION = 'ticket-description';
export const DESCRIPTION = 'description';
export const MORE_BUTTON = 'more-button';
export const MORE_PRICE_OPTIONS_BUTTON = 'more-price-options-button';
export const TOTAL = 'total';
export const PRICE = 'price';
export const SOLD_OUT_LABEL = 'sold-out-label';
export const DISCOUNT_NAME = 'discount-name';
export const AVATAR = 'avatar';
export const POLICY = 'policy';
export const CHECKBOX = 'checkbox';
export const CHECKBOX_INPUT = 'checkbox-input';
export const CHECKBOX_LABEL = 'checkbox-label';
export const NO_RADIO_BUTTON = 'no-radio-button';
export const YES_RADIO_BUTTON = 'yes-radio-button';
export const CLOSED_REGISTRATION = 'closed-registration';
export const EVENT_FULL_DATE = 'event-full-date';
export const TICKETS_UNAVAILABLE = 'tickets-unavailable';
export const SCHEDULE = 'schedule';
export const SCHEDULE_SUBTITLE = 'schedule-subtitle';
export const SCHEDULE_SEE_ALL = 'schedule-see-all';
export const NO_SCHEDULE_EMPTY_STATE = 'no-schedule-empty-state';
export const RECURRING_DATES_BUTTON = 'recurring-dates-button';
export const GROUPS_JOIN_BUTTON = 'groups-join-button';
export const GROUPS_ACTIVITY = 'groups-activity-indication';
export const SEATINGS_MODAL = 'seatings-modal';
export const SEATINGS_MODAL_SEAT_POPOVER = 'seatings-modal-seat-popover';
export const EVENT_INFO = 'event-info';
export const ADD = 'add';
export const TICKETS_DOWNLOAD_MODAL = 'tickets-download-modal';
export const ORDER_SUMMARY_MODAL = 'order-summary-modal';
export const ORDER_SUMMARY_MODAL_TITLE = 'order-summary-modal-title';
export const ACCESSIBILITY_MODE_BUTTON = 'accessibility-mode-button';
export const BACK = 'back';
export const ADD_TICKETS_TO_CART_BUTTON = 'ADD_TICKETS_TO_CART_BUTTON';
export const SEATING_BASKET = 'SEATING_BASKET';
export const SEATING_ACCESSIBILITY_MODE = 'SEATING_ACCESSIBILITY_MODE';
export const ACCESSIBILITY_MODE_END = 'ACCESSIBILITY_MODE_END';
export const REMOVE_TICKET = 'REMOVE_TICKET';
export const CLOSE_DRAWER = 'CLOSE_DRAWER';
export const SEATINGS_FOOTER = 'SEATINGS_FOOTER';
export const REVIEW_AND_CHECKOUT = 'REVIEW_AND_CHECKOUT';
export const VIEW_BASKET = 'VIEW_BASKET';
export const SEATING_PRICE_FILTER = 'SEATING_PRICE_FILTER';
export const SEATING_ZONE_FILTER = 'SEATING_ZONE_FILTER';
export const OPTION = 'dropdown-option';
export const FAKE_INPUT = 'fake-input';
export const DONATION_INPUT = 'donation-input';
export const TICKET_AREA_COUNTER = 'ticket-area-counter';
export const COUNTER_PLUS_BUTTON = 'counter-plus-button';
export const COUNTER_MINUS_BUTTON = 'counter-minus-button';
export const TICKET_LIMIT_REACHED_MODAL_BUTTON = 'ticket-limit-reached-modal-button';
export const PLACE_CAPACITY_REACHED_MODAL_BUTTON = 'place-capacity-reached-modal-button';
export const PRICES_LEGEND = 'prices-legend';
export const PRICES_OVERLAY = 'prices-overlay';
export const RESET_FILTERS = 'reset-filters';
export const ORDER_DETAILS = 'order-details';
export const MODAL_TITLE = 'modal-title';
export const MODAL_TEXT = 'modal-text';
export const TRY_AGAIN_BUTTON = 'try-again-button';
export const EMPTY_STATE_TITLE = 'empty-state-title';
export const ACCESSIBILITY_MAP_OVERLAY = 'accessibility-map-overlay';
export const TICKETS_COUNT = 'tickets-count';
export const TICKETS_LIST = 'tickets-list';
export const ORDER_EXPIRED = 'order-expired';
export const NEXT_TICKET_BUTTON = 'NEXT_TICKET_BUTTON';
export const SAME_AS_BUYER_CHECKBOX = 'SAME_AS_BUYER_CHECKBOX';
export const FIRST_NAME_CAPTION = 'first-name-caption';
export const FIRST_NAME_ERROR = 'first-name-error';
export const LAST_NAME_CAPTION = 'last-name-caption';
export const LAST_NAME_ERROR = 'last-name-error';
export const TICKET_PRICE_MODAL = 'ticket-price-modal';
export const PRICING_OPTIONS_MODAL = 'pricing-options-modal';
export const PRICING_OPTIONS = 'pricing-options';
export const PRICING_OPTIONS_DROPDOWN = 'pricing-options-dropdown';
export const PRIMARY_BUTTON = 'primary-button';
export const SECONDARY_BUTTON = 'secondary-button';
export const PRICING_OPTION = 'pricing-option';
export const SEAT_PRICING_OPTION_CONTAINER = 'seat-pricing-option-container';
export const CONFIRM_RSVP_MODAL = 'confirm-rsvp-modal';
export const SEATS_UNAVAILABLE_MODAL = 'seats-unavailable-modal';
export const SEATS_UNAVAILABLE_BUTTON = 'seats-unavailable-button';
export const SEATINGS_LOADER = 'seatings-loader';
export const SEATINGS_LOADER_CONTENT = 'seatings-loader-content';
export const MODAL_HEADER_TITLE = 'modal-header-title';
export const BACK_TO_MAP = 'back-to-map';
//# sourceMappingURL=details-page.js.map